/* Accesorios (20 oct 2026, GradedGuard).
   1) Página de la colección: filtro «Para tu slab» (Todos · PSA · CGC · BGS) sobre las tarjetas, sin peticiones.
   2) Ficha: el color elegido manda el id al formulario, muestra su precio, cambia la imagen grande (pulsa la
      miniatura con el mismo media id) y acota la cantidad a la existencia del color. Sin JS la ficha sigue
      comprando el color marcado, con cantidad 1. */
(function () {
  var filtro = document.querySelector('[data-acc-filtro]');
  var rejilla = document.querySelector('[data-acc-rejilla]');
  if (!filtro || !rejilla) return;
  var vacio = document.querySelector('[data-acc-vacio]');
  var botones = Array.prototype.slice.call(filtro.querySelectorAll('[data-casa]'));
  filtro.addEventListener('click', function (e) {
    var b = e.target.closest('[data-casa]');
    if (!b) return;
    var casa = b.getAttribute('data-casa') || '';
    botones.forEach(function (x) {
      var on = x === b;
      x.setAttribute('aria-pressed', on ? 'true' : 'false');
      x.classList.toggle('is-activo', on);
    });
    var n = 0;
    Array.prototype.slice.call(rejilla.children).forEach(function (t) {
      var ok = !casa || (t.getAttribute('data-casa') || '') === casa;
      t.hidden = !ok;
      if (ok) n += 1;
    });
    if (vacio) vacio.hidden = n > 0;
  });
})();

(function () {
  var raiz = document.querySelector('[data-acc-ficha]');
  if (!raiz) return;
  var idInput = raiz.querySelector('[data-acc-id]');
  var radios = Array.prototype.slice.call(raiz.querySelectorAll('input[name="acc-color"]'));
  var cantidad = raiz.querySelector('[data-acc-cantidad]');
  var nombre = raiz.querySelector('[data-acc-color-nombre]');
  var principal = document.querySelector('.ficha__principal .ficha__escaneo');

  function precios(id) {
    Array.prototype.slice.call(document.querySelectorAll('[data-precio-var]')).forEach(function (s) {
      s.hidden = s.getAttribute('data-precio-var') !== id;
    });
  }

  function tope() {
    var max = cantidad ? parseInt(cantidad.max, 10) : 99;
    return max > 0 ? max : 99;
  }

  function ajusta(delta) {
    if (!cantidad) return;
    var v = parseInt(cantidad.value, 10);
    if (!(v > 0)) v = 1;
    v = Math.min(tope(), Math.max(1, v + delta));
    cantidad.value = String(v);
  }

  function aplica(r, enUrl) {
    if (!r) return;
    var id = r.value;
    if (idInput) idInput.value = id;
    precios(id);
    if (nombre) nombre.textContent = r.getAttribute('data-nombre') || '';
    var max = parseInt(r.getAttribute('data-max'), 10);
    if (cantidad) {
      cantidad.max = String(max > 0 ? max : 99);
      ajusta(0);
    }
    var mediaId = r.getAttribute('data-media-id');
    var mini = mediaId ? document.querySelector('[data-miniatura][data-media-id="' + mediaId + '"]') : null;
    if (mini) {
      if (!mini.classList.contains('is-activa')) mini.click();
    } else if (principal && r.getAttribute('data-src')) {
      principal.srcset = '';
      principal.src = r.getAttribute('data-src');
    }
    if (enUrl) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      } catch (e) {}
    }
  }

  radios.forEach(function (r) {
    r.addEventListener('change', function () { aplica(r, true); });
  });

  var menos = raiz.querySelector('[data-acc-menos]');
  var mas = raiz.querySelector('[data-acc-mas]');
  if (menos) menos.addEventListener('click', function () { ajusta(-1); });
  if (mas) mas.addEventListener('click', function () { ajusta(1); });
  if (cantidad) cantidad.addEventListener('change', function () { ajusta(0); });

  /* Al cargar: la imagen grande es la del color marcado (Shopify respeta ?variant=) */
  var marcado = radios.filter(function (r) { return r.checked; })[0];
  if (marcado) aplica(marcado, false);
})();
